import React from "react";

export default function EmptyCart() {
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-10 mx-auto text-center text-title">
          <h2 className="text-center">Your cart is currently empty</h2>
        </div>
      </div>
    </div>
  );
}
